<div class="my-account-container pl-72 pr-72 pt-32 pb-32">
  <div class="mat-subtitle-2 fw-700 fs-24 mb-16">
    {{'MY_ACCOUNT.MY_ACCOUNT' | transloco}}
  </div>
  <div class="tabs-section p-24">
    <mat-tab-group animationDuration="0ms">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="section-label mt-8 mb-8 mat-headline-6 fw-500 fs-20">{{'MY_ACCOUNT.MY_PROFILE' | transloco }}</span>
        </ng-template>
        <div class="flex pt-28 mb-42 bg-section">
          <div>
            <mat-icon svgIcon="account_circle" class="account-icon"></mat-icon>
          </div>
          <div class="flex flex-col ml-32 mr-48">
            <div class="flex flex-col mb-24">
              <div>{{'MY_ACCOUNT.FIRST_NAME' | transloco }}</div>
              <div class="mt-12 fw-600">{{userInfo?.attributes?.given_name | titlecase}}</div>
            </div>
            <div>
              <div>{{'MY_ACCOUNT.EMAIL_ID' | transloco }}</div>
              <div class="mt-12 fw-600">{{userInfo?.attributes?.email}}</div>
            </div>
          </div>
          <div class="flex flex-col">
            <div>{{'MY_ACCOUNT.LAST_NAME' | transloco }}</div>
            <div class="mt-12 fw-600">{{userInfo?.attributes?.family_name | titlecase}}</div>
          </div>
        </div>
        <div class="mb-42">
          <div class="mat-headline-6 fw-700 fs-20 header-title pl-16 pt-8 pb-8">{{'MY_ACCOUNT.ASSIGNED_GROUPS' | transloco }}</div>
          <div class="mt-16 flex flex-wrap gap-6">
            <div *ngFor="let group of userInfo?.authorityGroups" class="group-name pl-16 pr-16 pt-8 pb-8 fw-500">{{group | titlecase}}</div>
          </div>
        </div>

        <div class="mb-24 permissions-section" [ngClass]="{'disabled': showLoader}">
          <div class="mat-headline-6 fw-700 fs-20 mb-0 header-title pl-16 pt-8 pb-8">{{'MY_ACCOUNT.ASSIGNED_PERMISSIONS' | transloco }}</div>
          <div class="pt-16">
            <div class="flex items-center mb-4">
              <label class="fw-700 fs-12 mat-subtitle-2">{{'MY_ACCOUNT.CHOOSE_TENANT'| transloco | uppercase}}</label> 
              <mat-icon svgIcon="info" class="icon-sm cursor-pointer ml-10" matTooltipClass="right" [matTooltip]="'MY_ACCOUNT.CHOOSE_TENANT' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <mat-select class="fw-500 form-select fs-16 tenant-list scope-dropdown"
             placeholder="{{'MY_ACCOUNT.CHOOSE' | transloco}}"
              panelClass="scope-dropdown-options" (selectionChange)="tenantChanged($event.value)"
              (closed)="resetDropdown()">
              <div class="flex relative m-8"><input [(ngModel)]="dropdownSearchValue"
                  (ngModelChange)="searchChanged(dropdownSearchValue)" class="fw-400 h-34 search-text pl-12"
                  placeholder="{{'SEARCH.SEARCH' | transloco}}" type="text">
                <span (click)="searchChanged(dropdownSearchValue)" class="cursor-pointer absolute"><mat-icon
                    class="icon-md icon-color search-icon mt-4" svgIcon="search"></mat-icon></span>
              </div>
              <mat-option *ngIf="!tenants || tenants?.length === 0">
                <div class="ml-16 mr-16 mt-8 mb-8">
                  {{'MY_ACCOUNT.NO_TENANT_FOUND' | transloco}}</div>
              </mat-option>
              <ng-container   *ngFor="let tenant of tenants; let i = index">
                <mat-option [value]="tenant.tenantId">{{tenant.tenantId}}</mat-option>
                <mat-divider *ngIf="i < tenants.length - 1" class="neutral-2 mb-4"></mat-divider>
              </ng-container>
            </mat-select>


            <div *ngIf="selectedTenant" class="mb-8 mt-24 mat-subtitle-2 fs-12 fw-700">
              {{ 'ROLES.RESOURCE' | transloco | uppercase }}:
            </div>
            <div *ngIf="selectedTenant" class="flex flex-wrap gap-3">
              <div class="pt-8 pb-8 pl-16 pr-16 tab-names cursor-pointer mat-subtitle-2 fs-16 fw-600" [ngClass]="{'selected': permission?.isSelected}"
                *ngFor="let permission of permissionsData" (click)="selectPermission(permission)">
                {{permission.header === ('ROLES.INSTANCE' | transloco) ? ('INSTANCE_DETAILS.INSTANCE' | transloco) : permission.header}}
              </div>
            </div>
        
            <div *ngIf="selectedTenant" class="permissions-table mt-24">
              <ng-container *ngIf="selectedPermission?.key !== 'instance' && selectedPermission?.key !== 'jumpboxes' && selectedPermission?.key !== 'pe-connections' && selectedPermission?.key !== 'authz' && selectedPermission?.key !== 'jobs' && selectedPermission?.key !== 'runbook' && selectedPermission?.key !== 'schedules'">
                <div class="others-header flex">
                  <div class="permission-header mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex pl-20">{{ 'ROLES.PERMISSIONS' | transloco }}</div>
                </div>
                <div class="pb-32">
                  <ng-container *ngFor="let permission of selectedPermission?.permissions">
                    <div class="others-section flex" *ngIf="!permission.dataZonePermissions">
                      <div class="permission pl-24 flex items-center mr-24 fw-500">
                        {{permission?.header}}
                      </div>
                      <div class="element pl-24 flex items-center mr-24 fw-500">
                        <mat-icon [svgIcon]="permission?.access ? 'done' : 'close'" [ngClass]="{'close': !permission?.access}"  class="icon-md-1"></mat-icon>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngIf="selectedPermission?.key === 'instance' || selectedPermission?.key === 'jumpboxes' || selectedPermission?.key === 'pe-connections' || selectedPermission?.key === 'authz' || selectedPermission?.key === 'jobs' || selectedPermission?.key === 'runbook' || selectedPermission?.key === 'schedules'">
                <div class="header flex">
                  <div class="permission mr-24 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex pl-20">{{ 'ROLES.PERMISSIONS' | transloco }}</div>
                  <div class="nonpii mr-16 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.READ' : 'ROLES.NON_PII') | transloco }}</div>
                  <div class="pii mr-16 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.CREATE' : 'ROLES.PII') | transloco }}</div>
                  <div class="live mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.UPDATE' : 'ROLES.PROD') | transloco }}</div>
                </div>
                <ng-container *ngFor="let permission of selectedPermission?.permissions">
                  <div class="body flex" *ngIf="permission.dataZonePermissions">
                    <div class="permission pl-24 flex items-center mr-24 fw-500">
                      {{permission?.header}}
                    </div>
                    <ng-container *ngFor="let element of permission.dataZonePermissions; let last = last">
                      <div class="element flex items-center justify-center fw-500" [ngClass]="{'mr-16': !last}">
                        <div>
                          <mat-icon [svgIcon]="element?.access ? 'done' : 'close'" [ngClass]="element?.access && element?.infoDetails && element?.infoDetails?.length > 0 ? 'done' : !element?.access ? 'close' : ''"  class="icon-md-1"></mat-icon>
                        </div>
                        <span *ngIf="element?.access && element?.infoDetails && element?.infoDetails?.length > 0" class="info-icon">
                          <mat-icon svgIcon="info" class="icon-sm cursor-pointer" [matMenuTriggerFor]="tooltipContent"></mat-icon>
                        </span>
                        <mat-menu #tooltipContent [xPosition]="'before'" class="roles-tooltip">
                          <div class="p-12">
                            <div class="type-header mat-subtitle-2 fs-14 fw-600 pb-4 mb-8">{{'ROLES.INSTANCE_TYPE' | transloco}}</div>
                            <div class="fs-14 fw-500" *ngFor="let type of element?.infoDetails; let i = index">
                              {{i + 1}}.<span class="pl-4">{{ type === 'others' ? (type | titlecase) : (type | uppercase)}}</span>
                            </div>
                          </div>
                        </mat-menu>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="dataZonePermissions(selectedPermission?.permissions) && selectedPermission?.key !== 'instance' && selectedPermission?.key !== 'jumpboxes' && selectedPermission?.key !== 'pe-connections' && selectedPermission?.key !== 'authz' && selectedPermission?.key !== 'jobs' && selectedPermission?.key !== 'runbook' && selectedPermission?.key !== 'schedules'">
                <div class="tenant-header flex">
                  <div  class="permission mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex pl-20"></div>
                  <div class="nonpii mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ 'ROLES.NON_PII' | transloco }}</div>
                  <div class="pii mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ 'ROLES.PII' | transloco }}</div>
                  <div class="live mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ 'ROLES.PROD' | transloco }}</div>
                </div>
                <ng-container *ngFor="let permission of selectedPermission?.permissions">
                  <div class="tenant-body flex" *ngIf="permission.dataZonePermissions">
                    <div class="permission pl-24 flex items-center fw-500">
                      {{permission?.header}}
                    </div>
                    <ng-container *ngFor="let element of permission.dataZonePermissions; let last = last">
                      <div class="element flex items-center justify-center fw-500">
                        <div>
                          <mat-icon [svgIcon]="element?.access ? 'done' : 'close'" [ngClass]="element?.access && element?.infoDetails && element?.infoDetails?.length > 0 ? 'done' : !element?.access ? 'close' : ''"  class="icon-md-1"></mat-icon>
                        </div>
                        <span *ngIf="element?.access && element?.infoDetails && element?.infoDetails?.length > 0" class="info-icon">
                          <mat-icon svgIcon="info" class="icon-sm cursor-pointer" [matMenuTriggerFor]="tooltipContent"></mat-icon>
                        </span>
                        <mat-menu #tooltipContent [xPosition]="'before'" class="roles-tooltip">
                          <div class="p-12">
                            <div class="type-header mat-subtitle-2 fs-14 fw-600 pb-4 mb-8">{{'ROLES.INSTANCE_TYPE' | transloco}}</div>
                            <div class="fs-14 fw-500" *ngFor="let type of element?.infoDetails; let i = index">
                              {{i + 1}}.<span class="pl-4">{{ type === 'others' ? (type | titlecase) : (type | uppercase)}}</span>
                            </div>
                          </div>
                        </mat-menu>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="section-label mt-8 mb-8 mat-headline-6 fw-500 fs-20">{{'MY_ACCOUNT.ACCESS_TOKEN' | transloco }}</span>
        </ng-template>
        <div class="pb-16 mt-24 flex justify-end">
          <mat-icon svgIcon="refresh" class="icon-md-1 cursor-pointer mr-24" [ngClass]="refreshRotate ? 'rotate' : ''" (click)="refreshClick()"></mat-icon>
          <mat-icon svgIcon="content_copy" class="icon-md-1 cursor-pointer" (click)="onCopy()" [cdkCopyToClipboard]="token"></mat-icon>
        </div>
        <div class="bg-section token p-16">
          {{token}}
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div *ngIf="showLoader">
  <mat-card class="flex spinner-container load-spinner">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
</div>
